module.exports = __webpack_public_path__ + "static/media/siebel0.80ef910e.png";